import React from 'react';
import SubServices from '../common/sub-services';
const WoocommerceServies = () => {
    return (
        <div className="section-py bg-grey dark:bg-black">
            <div className="container lg:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="text-center lg:col-span-8 lg:col-start-3 pb-50">
                        <p
                            className="text-primary mb-0 fs-lg fw-700"
                            data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200"
                        >
                            We Provide
                        </p>
                        <h2 data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            WooCommerce Development Services
                        </h2>
                    </div>
                </div>
                <div className="row grid xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 lg:w-8/12 mx-auto">
                    <SubServices
                        path={'/img/technology/ic-woocommerce-plugin.svg'}
                        height={64}
                        width={64}
                        alt="woocommerce-plugin"
                        title="woocommerce-plugin"
                        serviceName="WooCommerce Plug-Ins"
                        serviceDescription="Having a wide range of plugin collections, we deliver best-in-class solutions embedded with awesome yet functional plugins."
                    />
                    <SubServices
                        path={'/img/technology/ic-budget-friendly.svg'}
                        height={64}
                        width={64}
                        alt="budget-friendly"
                        title="budget-friendly"
                        serviceName="Budget-Friendly"
                        serviceDescription="Whether you want to make your store more functional or expand payment options, we ensure you leverage complete WooCommerce solutions within your budget."
                    />
                    <SubServices
                        path={'/img/technology/ic-customization.svg'}
                        height={64}
                        width={64}
                        alt="spas"
                        title="spas"
                        serviceName="WooCommerce Customizations"
                        serviceDescription="We design and develop unbeatable WooCommerce themes on your business workflow and the latest design trends."
                    />
                    <SubServices
                        path={'/img/technology/ic-psd-to-woocommerce.svg'}
                        height={64}
                        width={64}
                        alt="psd-to-woocommerce"
                        title="psd-to-woocommerce"
                        serviceName="PSD to WooCommerce"
                        serviceDescription="Our WooCommerce experts hold immense ability to convert your PSD files into WooCommerce and build a strong online store that meets your business requirements"
                    />
                </div>
            </div>
        </div>
    );
};

export default WoocommerceServies;
